import { useCallback, useRef, DependencyList } from 'react';

export function useThrottledCallback<
  T extends (...args: any[]) => any,
>(callback: T, deps: DependencyList, milliseconds?: number): T {
  const memoizedCallback = useCallback(callback, deps);

  const timeoutId = useRef<ReturnType<typeof setTimeout> | number>(0);
  const callbackAlreadyCalled = useRef(false);

  const throttledCallback = useCallback(
    (e: any) => {
      if (!callbackAlreadyCalled.current) {
        callbackAlreadyCalled.current = true;
        memoizedCallback(e);

        timeoutId.current = setTimeout(() => {
          callbackAlreadyCalled.current = false;
        }, milliseconds);
      }
    },
    [milliseconds],
  );

  return throttledCallback as T;
}
